import { Controller } from "@hotwired/stimulus"

// jedyna opcja stawki po zaznaczeniu odwrotnego obciążenia — nabywca PL/bez kraju: "oo",
// nabywca zagraniczny: "np" (parytet z bootstrapem, _form_reverse_charge_pl.js.erb)
export default class extends Controller {
  static targets = ["checkbox"]
  static outlets = ["invoice", "invoice--tax-rate"]
  static values = { forceCheck: Boolean }

  connect() {
    if (this.checkboxTarget.checked) {
      this.applyOnLoad()
    } else if (this.forceCheckValue) {
      requestAnimationFrame(() => {
        this.checkboxTarget.checked = true
        this.toggle({ target: this.checkboxTarget })
      })
    }
  }

  applyOnLoad() {
    const taxRate = this.invoiceTaxRateOutlet

    if (this.invoiceOutlet.buyerCountryTarget.value === "") this.invoiceOutlet.buyerCountryTarget.value = "PL"
    taxRate.lockTax("reverse-charge")
    taxRate.updateNaKindVisibility()
    taxRate.updateTechnicalTaxVisibility()
    this.updateNotSpecifiedAvailability(true)
  }

  toggle(event) {
    this.apply(event.target.checked)
    this.dispatch("changed", { detail: { checked: event.target.checked } })
  }

  updateBuyerCountry() {
    if (this.checkboxTarget.checked) this.apply(true)
  }

  handleMossChanged(event) {
    this.element.classList.toggle("hidden", event.detail.checked)
  }

  apply(checked) {
    const taxRate = this.invoiceTaxRateOutlet

    if (checked) {
      if (this.invoiceOutlet.buyerCountryTarget.value === "") this.invoiceOutlet.buyerCountryTarget.value = "PL"

      taxRate.captureTechnicalTax()
      taxRate.lockTax("reverse-charge")
      taxRate.lockTaxTo(this.reverseChargeTax())
    } else {
      taxRate.unlockTax("reverse-charge")
      taxRate.restoreDefaultTaxAfterReverseCharge()
      taxRate.resetNpTaxKindInner()
    }

    taxRate.updateNaKindVisibility()
    taxRate.updateTechnicalTaxVisibility()
    this.updateNotSpecifiedAvailability(checked)
  }

  reverseChargeTax() {
    const country = this.invoiceOutlet.buyerCountryTarget.value
    return (country === "" || country === "PL") ? "oo" : "np"
  }

  checkNpTaxKindInner(event) {
    const checkbox = event.target
    if (!checkbox.checked) return

    const countryIsPl = ["", "PL"].includes(this.invoiceOutlet.buyerCountryTarget.value)

    if (countryIsPl) {
      if (confirm(this.invoiceOutlet.translationsValue["reverse_charge_confirm_msg_pl"])) {
        this.invoiceOutlet.buyerCountryTarget.focus()
        this.invoiceOutlet.buyerCountryTarget.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" })
      }
      checkbox.checked = false
      checkbox.dispatchEvent(new Event("change"))
      return
    }

    if (this.checkboxTarget.checked || confirm(this.invoiceOutlet.translationsValue["reverse_charge_confirm_msg_other"])) {
      this.checkboxTarget.checked = true
      this.checkboxTarget.dispatchEvent(new Event("change"))
    } else {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event("change"))
    }
  }

  updateNotSpecifiedAvailability(checked) {
    const taxRate = this.invoiceTaxRateOutlet
    if (!taxRate.hasNaTaxKindRadiosTarget) return

    const notSpecifiedRadio = taxRate.naTaxKindRadiosTarget.querySelector('input[value="not_specified"]')
    if (!notSpecifiedRadio) return

    const countryIsPl = ["", "PL"].includes(this.invoiceOutlet.buyerCountryTarget.value)
    if (checked && !countryIsPl) {
      if (notSpecifiedRadio.checked) taxRate.selectExportServiceNaTaxKind()
      notSpecifiedRadio.disabled = true
    } else {
      notSpecifiedRadio.disabled = false
    }
  }
}
